module.exports = __webpack_public_path__ + "img/product2.b5fc941c.png";